<script lang="ts">
	import { storyblokEditable } from '@storyblok/svelte';
	import { t } from 'svelte-i18n';

	export let blok: {
		title: string;
		items: [
			{
				lineWithoutNumbers: string;
				lineWithNumbersBigText: string;
				lineWithNumbersSmallText: string;
				reverseLineWithNumbersTextsOrder: boolean;
				switchOrder: boolean;
			}
		];
	};
</script>

<div use:storyblokEditable={blok} class="h-0 benefits">
	<div class="container">
		<div class="lg:px-6">
			<div
				class="relative shadow-xl rounded-lg bg-white p-4 space-y-5 transform -translate-y-1/2 md:flex md:items-center md:justify-between md:space-y-0 md:gap-4 lg:px-6 max-w-[1068px] m-auto"
			>
				{#if blok.title}
					<div class="text-[28px] font-semibold lg:text-left">{blok.title}</div>
				{/if}
				{#each blok.items as item, i}
					<div
						use:storyblokEditable={item}
						class="{!blok.title && i===0 ? '' : 'border-l'} pl-3 flex flex-col gap-1 {item.switchOrder ? 'flex-col-reverse' : ''}"
					>
						<div class="font-semibold">
							{item.lineWithoutNumbers}
						</div>
						<div class="flex items-baseline gap-1 {item.reverseLineWithNumbersTextsOrder ? 'flex-row-reverse justify-end' :''}">
							<div class="text-3xl">{item.lineWithNumbersBigText}</div
							> <div class="">{item.lineWithNumbersSmallText}</div>
						</div>
					</div>
				{/each}
				<div class="absolute w-full left-0 top-[95%] md:top-[110%] text-center text-xs italic text-grey-dark">
					{$t('legalWarning')}
				</div>
			</div>
		</div>
	</div>
</div>
